import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { parseRequired } from '../../../Utils/form.util';
import { loadDOMComponent } from '../../../helpers';
import { store } from '../../../store/store';
import { AppContextProvider } from '../../../Services/AppContext';
import VideoWithPlayCountInput from './VideoWithPlayCountInput';

loadDOMComponent({
	selector: 'react-video-with-play-count',
	callback: ({ container, context, props }: any) => {
		const src = container.getAttribute('data-src');
		const name = container.getAttribute('name');
		const netteRules = container.getAttribute('data-nette-rules');
		const playDelayInSeconds = parseInt(
			container.getAttribute('playDelayInSeconds'),
		);
		const maxPlays = parseInt(container.getAttribute('maxPlays'));
		const playRequired = parseRequired(container.getAttribute('playRequired'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<VideoWithPlayCountInput
						video={src}
						name={name}
						netteRules={netteRules}
						playDelayInSeconds={playDelayInSeconds}
						maxPlays={maxPlays}
						playRequired={playRequired}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
